<script>
import ResetPasswordForm from "@/components/ResetPasswordForm.vue";
import axios from "axios";

export default {
  data() {
    return {
      isEdit: false,
      token: null,
      isTokenValid: null,
    }
  },
  components: {
    ResetPasswordForm
  },
  mounted() {
    this.isEdit = this.$route.name === 'reset-password/reset-reset'
    this.token = this.$route.params.token
    this.checkIfTokenIsValid()
  },
  methods: {
    checkIfTokenIsValid() {
      axios.get(process.env.VUE_APP_API_URL + '/reset-password/check-token/' + this.token).then(response => {
        this.isTokenValid = response.data.isValid
        console.log(this.isTokenValid);
      }).catch(
          this.flash = {
            message: 'Une erreur est survenue lors de la vérification de votre lien, veuillez reesayer plus tard',
            type: 'danger'
          }
      )
    },
  }
}
</script>

<template>
  <div class="container" v-if="isTokenValid !== null">
    <div class="mb-3">
      <a href="/">Retour à la connexion</a>
    </div>
    <h1 class="text-center" v-if="isEdit">Modification de mot de passe</h1>
    <h1 class="text-center" v-else>Création de mot de passe</h1>
    <div v-if="isTokenValid === false" class="text-center">
      <p>Votre lien de <span v-if="isEdit">modification</span><span v-else>création</span> de mot de passe a
        <b>expiré</b>. Cliquez sur le bouton ci-dessous pour en créer un nouveau.</p>
      <a href="/reset-password" class="btn btn-primary">Cliquez ici</a>
    </div>
    <ResetPasswordForm :is-edit="isEdit" v-if="isTokenValid === true"/>
  </div>
</template>

<style scoped>

</style>